import { BrowserCacheLocation } from '@azure/msal-browser';
import { env } from '@helpers';

import { envVars } from './env';

const currentUrl = new URL(document.URL);
const hostUrl = currentUrl.origin;
const isLocalEnvironment =
  currentUrl.protocol === 'http:' &&
  currentUrl.port === '1234' &&
  ['localhost', '127.0.0.1', '::1', '[::1]'].includes(currentUrl.hostname);

const apiBaseUrl = env(envVars.V2_API_BASE_URL, 'staging.rflx.co.uk/');

const supportRoot = 'https://support.reflexivity.com/';

export const config = {
  posthog: {
    apiKey: env(
      envVars.PUBLIC_POSTHOG_KEY,
      'phc_35D7KlZlWdxkmcD1DvL8krr8pwlO9rz9KvDGDUFsvCm'
    ),
    apiHost: env(envVars.PUBLIC_POSTHOG_HOST, 'https://ph.rflx.co.uk'),
    uiHost: 'https://us.posthog.com',
  },
  app: {
    version: env(envVars.V2_VERSION, ''),
    environment: env(envVars.V2_ENV_LEVEL, 'staging'),
    isLocalEnvironment,
    featureFlags: env(envVars.V2_FEATURE_FLAGS, '')?.split(','),
    isTeamsApp: env(envVars.V2_TEAMS_APP, '') === 'true',
  },
  release: {
    date: env(envVars.V2_RELEASE_DATE, new Date().toISOString()),
    number: env(envVars.V2_RELEASE_NUMBER, '1.1.0'),
  },
  api: {
    root: `https://api.${apiBaseUrl}`,
    wsRoot: `wss://ws.${apiBaseUrl}v2/prices`,
    wsDelayedRoot: `wss://ws.${apiBaseUrl}v1/delayed-prices`,
    wsNotifierRoot: `wss://ws.${apiBaseUrl}v2/notifier`,
    authRoot: `https://authn.${apiBaseUrl}`,
  },
  urls: {
    root: hostUrl,
    webAppOrigin: env(envVars.WEBSITE_DOMAIN, hostUrl).replace(/\/$/, ''),
    supportRoot,
    supportNewTicket: `${supportRoot}hc/en-us/requests/new`,
    onboardingUrl: 'https://calendar.app.google/2FnsHDLsCwwoTCEW7',
    disclaimerFileUpload:
      'https://support.reflexivity.com/hc/en-us/articles/45048745062548-Important-Disclosure-about-Uploading',
    helpImportWatchlist:
      'https://support.reflexivity.com/hc/en-us/articles/29753957516564-How-to-import-your-watchlist-from-Bloomberg',
  },
  ib: {
    website:
      'https://ndcdyn.interactivebrokers.com/sso/Login?action=TA_MARKET_DATA&loginType=1&serviceID1=1357&serviceID2=1064&serviceID3=1065',
    linkDisclaimer: env(
      envVars.V2_IB_LINK_DISCLAIMER,
      'https://support.reflexivity.com/hc/en-us/articles/40656423190548-Important-Disclaimers-about-Direct-Linkage'
    ),
  },
  zendeskSubdomain: env(
    envVars.V2_ZENDESK_SUBDOMAIN,
    'https://toggleglobal.zendesk.com/api/v2/requests'
  ),
  supportUrl: 'https://support.reflexivity.com/hc/en-us/requests/new',
  stripePublicKey: env(
    envVars.V2_STRIPE_PUBLIC_KEY,
    'pk_test_51Mdw3pG1Cyr3tMwe60lnBGMRRRlj3ifDQ3wTTdVe2Lz7rIE8aQVg3ntM8wfhtGPyF431iUVl0Yo9k5pnUCdBUZWO00nRitX4J8'
  ),
  faro: {
    url: env(
      envVars.FARO_URL,
      'https://faro-collector-prod-us-east-2.grafana.net/collect/47d752fe88600d31a3c539c6455d7bc1'
    ),
  },
  microsoft: {
    config: {
      auth: {
        clientId: env(
          envVars.MS365_CLIENT_ID,
          '388983d4-d79a-4ef9-afb3-5d6d843b7e4f'
        ),
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: `https://${apiBaseUrl}app/alfred/app-connection`,
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
      },
    },
    scopes: [
      `api://${env(
        envVars.MS365_CLIENT_ID,
        '388983d4-d79a-4ef9-afb3-5d6d843b7e4f'
      )}/access_as_user`,
    ],
  },
  supportEmail: 'support@reflexivity.com',
  partnershipsEmail: 'partnerships@reflexivity.com',
};

export const webOnlyFeat = <T>(value: T): T | undefined =>
  config.app.isTeamsApp ? undefined : value;
